import {
    type FC
} from "react";
import {
    type TextStyle,
    Animated,
    Platform,
    Text
} from "react-native";
import type IMarkerContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useMarkerContext
} from "../../context";
import {
    warnOnce
} from "../../../../utils/development";

const AnimatedText = Platform.OS === "web" ? Text : Animated.Text;

const MarkerContent: FC<IMarkerContentProps> = ({
    customTheme,
    children,
    style,
    ...props
}) => {
    const context = useMarkerContext();

    const {
        typography,
        durations
    } = NCoreUIKitTheme.useContext(customTheme ?? context?.customTheme);

    const {
        webBreathe: webBreatheDynamicStyle
    } = useStyles({
        to: context?.currentColors.emphasizedColor,
        from: context?.currentColors.textColor,
        duration: durations.breathe
    });

    if(!context) {
        warnOnce({
            message: "Marker.Content: it must be rendered inside a Marker."
        });

        return null;
    }

    const isWebBreathing = Platform.OS === "web" && context.isPending && !context.isReduced;

    const textColor = context.breathe ? context.breathe.interpolate({
        outputRange: [
            context.currentColors.textColor,
            context.currentColors.emphasizedColor
        ],
        inputRange: [
            0,
            1
        ]
    }) : context.currentColors.textColor;

    return <AnimatedText
        {...props}
        style={[
            style,
            stylesheet.text,
            {
                ...typography[context.typography],
                color: textColor
            } as TextStyle,
            isWebBreathing && webBreatheDynamicStyle
        ]}
    >
        {children}
    </AnimatedText>;
};
export default MarkerContent;
